var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import clsx from 'clsx';
import BrandHeader from './BrandHeader';
import LocalNavigationHeader from './localNavigation/LocalNavigationHeader';
import style from './Header.module.scss';
import ServiceMenu from './ServiceMenu';
import { AperzaUserProvider } from './AperzaUserContext';
import { useAperzaUser } from './UseAperzaUser';
import { AccountHeader } from './AccountHeader';
import { HeaderSearch } from './HeaderSearch';
import { MobileMenuButton } from './menulist/MobileMenuButton';
import { useResponsive } from '../utils/UseResponsive';
import { ResponsiveProvider } from '../utils/ResponsiveContext';
import EnvironmentIndicator from './EnvironmentIndicator';
import ServiceLogo from '../utils/ServiceLogo';
// TODO : in future put query to get notification from db
// Static NOTIFICATIONs
var notifications = [
    { title: 'プライバシーポリシー改定のお知らせ', url: 'https://www.aperza.co.jp/news/%e3%83%97%e3%83%a9%e3%82%a4%e3%83%90%e3%82%b7%e3%83%bc%e3%83%9d%e3%83%aa%e3%82%b7%e3%83%bc%e6%94%b9%e5%ae%9a%e3%81%ae%e3%81%8a%e7%9f%a5%e3%82%89%e3%81%9b/' },
];
export function Header(_a) {
    var _b;
    var type = _a.type, fixed = _a.fixed, user = _a.user, unreadMessageCount = _a.unreadMessageCount, children = _a.children;
    var methods = useAperzaUser({ user: user, serviceType: type, notifications: notifications, unreadMessageCount: unreadMessageCount });
    var responsiveMethods = useResponsive();
    return (_jsx(ResponsiveProvider, __assign({}, responsiveMethods, { children: _jsx(AperzaUserProvider, __assign({}, methods, { children: _jsxs("header", __assign({ className: clsx(style.header, (_b = {}, _b[style.fixedHeader] = fixed, _b)) }, { children: [_jsx(EnvironmentIndicator, {}), _jsx(BrandHeader, { fixed: fixed }), responsiveMethods.isDesktop && (_jsxs("div", __assign({ className: style.mainHeader }, { children: [_jsx(ServiceLogo, {}), _jsx(ServiceMenu, {}), _jsx(HeaderSearch, {}), _jsx(AccountHeader, {})] }))), responsiveMethods.isMobile && (_jsxs("div", __assign({ className: style.mobileMainHeader }, { children: [_jsxs("div", __assign({ className: style.mobileServiceRow }, { children: [_jsx("div", __assign({ className: style.mobileServiceLogoWrapper }, { children: _jsx(ServiceLogo, {}) })), _jsx(MobileMenuButton, {})] })), _jsx(HeaderSearch, {})] }))), _jsx(LocalNavigationHeader, { fixed: fixed }), children && (_jsx(_Fragment, { children: _jsx("div", __assign({ className: style.childWrapper }, { children: children })) })), _jsx("div", { className: style.headerBorder })] })) })) })));
}
